export class ProductCardSwiper {
    constructor() {
        this.init();
        this.product_card_selector = '[product-card]';
    }

    init() {
        document.addEventListener('DOMContentLoaded', () => {
            this.findProductCards();
        });
        // this.cardsAddedToDOM();
    }

    findProductCards() {
        const product_cards = document.querySelectorAll(this.product_card_selector);

        if (product_cards.length > 0) {
            product_cards.forEach((card) => {
                this.initSwiper(card);
            });
        }
    }

    initSwiper(card) {
        const swiper_el = card.querySelector('.swiper');
        if (!swiper_el) {
            return;
        }
        const swiper = new window.swiper(swiper_el, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            lazy: true,
            nested: true,
            pagination: {
                el: card.querySelector('.swiper-pagination'),
                clickable: false,
            }
        })
    }

    cardsAddedToDOM() {
        const targetNode = document;

        // Create a MutationObserver instance
        const observer = new MutationObserver((mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
            mutation.addedNodes.forEach((node) => {
                console.log("Node type:", node.nodeType);
                if (node.nodeType === Node.ELEMENT_NODE || node.nodeType === Node.TEXT_NODE && node.hasAttribute('product-card')) {
                    console.log('New element added with [product-card] attribute:', node);
                    this.initSwiper(node);
                }
            });
            }
        }
        });

        // Observer configuration: Watch for child nodes being added
        const config = { childList: true, subtree: true };

        // Start observing the target node
        observer.observe(targetNode, config);
    }
}